<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<WizardLayout v-bind="$attrs"/>
</template>

<script>

import BaseWizard from "@/core/components/Wizard/BaseWizard.vue";
import WizardLayout from "@/core/components/Wizard/WizardLayout.vue";
import WizardStep from "@/core/components/Wizard/WizardStep";
import AddAgreementStep from "@/core/modules/coach/Coaching/Templates/Wizard/AddAgreementStep.vue";
import ConnectCalendarStep from "@/core/modules/coach/Coaching/Templates/Wizard/ConnectCalendarStep.vue";
import SetupNameStep from "@/core/modules/coach/Coaching/Templates/Wizard/SetupNameStep.vue";
import SetupSessionsStep from "@/core/modules/coach/Coaching/Templates/Wizard/SetupSessionsStep.vue";
import SetupPricingStep from "@/core/modules/coach/Coaching/Templates/Wizard/SetupPricingStep.vue";
import SetupBillingMethodsStep from "@/core/modules/coach/Coaching/Templates/Wizard/SetupBillingMethodsStep.vue";
import IntroStep from "@/core/modules/coach/Coaching/Templates/Wizard/IntroStep.vue";

export default {
	name: "TemplateCreationWizard",
	components: {WizardLayout},
	extends: BaseWizard,

	props:{
		canShowIntro: Boolean
	},

	methods: {

		async wizardSteps() {
			let stateObject = this.getStateObject() || {data: {}}
			let stateData = stateObject.data
			let canShowIntro = stateData.showIntro || !await this.$dataManager.hasProgramTemplates()
			let needConnectCalendarStep = stateData.showCalendar || !this.userProfile.schedulerSettings.isSetupCompleted
			let needSetupBilling = stateData.showBilling || !await this.$dataManager.apiGetHasPaymentIntegrations()

			let queryOptions = {}
			if (canShowIntro) {
				queryOptions.showIntro = true
			}
			if (needConnectCalendarStep) {
				queryOptions.showCalendar = true
			}
			if (needSetupBilling) {
				queryOptions.showBilling = true
			}

			console.log("WizardLayout: queryOptions = ", queryOptions)
			await this.saveStateData(queryOptions)
			return [
				canShowIntro ? new WizardStep("Intro", IntroStep) : null,
				new WizardStep("Set up program name", SetupNameStep),
				new WizardStep("Add agreement", AddAgreementStep),
				needConnectCalendarStep ? new WizardStep("Connect your calendar", ConnectCalendarStep) : null,
				new WizardStep("Set up sessions", SetupSessionsStep),
				new WizardStep("Set up pricing", SetupPricingStep),
				needSetupBilling ? new WizardStep("Set up billing methods", SetupBillingMethodsStep) : null,
			].filter(step => step != null)
		},

		onWizardResult(wizardData){
			return wizardData["create_program_step"]
		},



		queryParamsToRemoveOnClose() {
			return ["showCalendar", "showBilling"]
		},

		getSyncUrlParams() {
			let params = {
				wizard: "program"
			}
			console.log("TemplateCreationWizard: getSyncUrlParams = ", params)
			return params
		},

		onSaveState() {
			let wizardData = this.getWizardData()
			console.log("wizardData = ", wizardData)
			let programItem = wizardData['create_program_step']
			if (programItem) {
				return {programId: wizardData['create_program_step'].id}
			}
		},

		async onRestoreState(data) {
			let programId = data.programId
			if (programId) {
				let wizardData = this.getWizardData()
				wizardData['create_program_step'] = await this.$dataManager.getProgram(data.programId)
			}
		},

		onRestoreStateForStep(stepIndex) {
			return this.getWizardData()
		}

	}

}
</script>

<style lang="scss">

</style>
